var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useCallback, useMemo } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import toast from 'react-hot-toast';
import { translate } from '@utils/i18n';
import api from '@utils/axios';
import Table, { TableSize } from '@components/Table';
import SearchPanel from '@components/SearchPanel';
import { Loader, LoaderSizes } from '@components/Loader/Loader';
import Brushaway from '@components/Brushaway';
import { namespace, supportEmail } from './constants';
import { gocanvasFormsPath } from '../../../../routes';
import LocationDisplay from '../../FormLibrary/LocationDisplay';
import { useGocanvasTemplates } from '../../FormLibrary/useTemplates';
function ImportForm({ isOpen, onClose, onImported }) {
    const [searchText, setSearchText] = useState('');
    const { templates, loading, removeTemplate } = useGocanvasTemplates(searchText);
    const importTemplate = useCallback((template) => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.post(gocanvasFormsPath({ format: 'json', template_id: template.id }));
            const form = response.data;
            onImported(form);
            removeTemplate(template);
            toast.success(translate('import.success_import', { namespace }));
        }
        catch (error) {
            toast.error(translate('import.failed_import', { namespace }));
        }
    }), [onImported, removeTemplate]);
    const mailtoLink = useMemo(() => {
        const subject = translate('import.mailto.subject', { namespace });
        const body = translate('import.mailto.body', { namespace });
        const linkText = translate('import.mailto.link_text', { namespace });
        const mailto = `mailto:${supportEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        return (React.createElement("a", { href: mailto, target: "_blank", rel: "noopener noreferrer" }, linkText));
    }, []);
    const columns = useMemo(() => [
        {
            label: translate('headers.display_name', { namespace }),
            dataKey: 'displayName',
            renderer: ({ item }) => (React.createElement("div", null,
                item.pdfFileUrl ? (React.createElement("a", { href: item.pdfFileUrl, target: "_blank", rel: "noopener noreferrer" }, item.displayName)) : (React.createElement("span", null, item.displayName)),
                item.isPrivate && (React.createElement("span", { className: "form-badge--private" }, translate('import.private_form', { namespace })))))
        },
        {
            label: translate('headers.location', { namespace }),
            dataKey: 'location',
            renderer: ({ item }) => React.createElement(LocationDisplay, { city: item.city, state: item.state, country: item.country })
        },
        {
            label: '',
            dataKey: 'id',
            renderer: ({ item }) => (React.createElement("button", { type: "button", className: "qmb-control", onClick: () => importTemplate(item) }, translate('import.import_button', { namespace })))
        }
    ], [importTemplate]);
    return (React.createElement(Brushaway, { open: isOpen, title: translate('add_form', { namespace }), onClose: onClose },
        React.createElement("div", { className: "missing-form-message", dangerouslySetInnerHTML: {
                __html: translate('import.missing_form', {
                    namespace,
                    link: renderToStaticMarkup(mailtoLink)
                })
            } }),
        React.createElement("div", { className: "filters__group--search mb-3" },
            React.createElement(SearchPanel, { value: searchText, placeholder: translate('search', { namespace: 'filters' }), onChange: setSearchText })),
        React.createElement("div", null, loading ? (React.createElement("div", { className: "loading-center" },
            React.createElement(Loader, { size: LoaderSizes.xlarge }))) : (React.createElement(Table, { columns: columns, data: templates, size: TableSize.Full, variant: "listing" })))));
}
export default ImportForm;
